import { jsx as _jsx } from "react/jsx-runtime";
import { useLocationDescriptionText } from "@/components/Sections/Description";
import { useRefsContext } from "@/contexts/ref";
import { Description } from "@/components/Sections/Description/Description";
import { Box } from "@gemini/core";
export const locationDescriptionTestId = "cdp-location-description";
export const LocationDescription = () => {
    const { headline, text } = useLocationDescriptionText();
    const { locationDescriptionRef } = useRefsContext();
    if (!headline || !text) {
        return null;
    }
    return (_jsx(Box, { ref: locationDescriptionRef, marginTop: {
            "breakpoint.base": "spacing.24",
            "breakpoint.lg": "spacing.32",
        }, children: _jsx(Description, { avZone: "classified_location_text", testId: locationDescriptionTestId, text: text }) }));
};
